export const manifestLocales = {
  main: {
    previewImageAlt: {
      en: 'Flex Section',
      he: 'מקטע'
    }
  }
};
